import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form','addButton'];
  static classes = ['errorm','hide'];
  static values = {uploadurl: String, removeimageurl: String, addimagefieldurl: String};

  formTargetConnected() {
    const index = document.getElementById("image_index");
    this.removeAddButton(Number(index.value));
  }

  addUploadField(){
    const uploadField = document.getElementById("diagnostic_image_upload_field");
    const formData = new FormData(this.formTarget);
    const index = document.getElementById("image_index");
    formData.append("index",index.value);
    formData.append("jsc","admin--reservations--edit-diagnostic");
    Rails.ajax({
      url: this.addimagefieldurlValue,
      type: "POST",
      dataType: 'html',
      data: formData,
      success: (response) => {
        uploadField.innerHTML = response.body.innerHTML;
      }
    });
    this.removeAddButton(Number(index.value)+1);
  }

  autoUpload(event){
    const el = event.currentTarget;
    const params = event.params;
    const targetName = params.targetname;
    const index = params.index;
    if(el.value != null && el.value != ""){
      const formData = new FormData(this.formTarget);
      formData.append("type",targetName);
      formData.append("index",index);
      Rails.ajax({
        url: this.uploadurlValue,
        type: "POST",
        dataType: 'json',
        data: formData,
        success: (response) => {
          if(response.error != null){
            document.getElementById("diagnostic_images_"+targetName+"_error_message").textContent = response.error;
          }else {
            const viewDiv = document.getElementById("image_view_" + targetName);
            const image = viewDiv.querySelector("img");
            image.src = response.image_url;
            viewDiv.classList.remove(this.hideClass);
            document.getElementById("image_upload_" + targetName).classList.add(this.hideClass);
            document.getElementById("diagnostic_images_id_" + index).value = response.di_id;
            document.getElementById("diagnostic_images_" + targetName + "_error_message").textContent = "";
          }
        }
      });
    }
  }

  removeImage(event){
    const params = event.params;
    const targetName = params.targetname;
    const formData = new FormData(this.formTarget);
    const index = params.index;
    formData.append("type",targetName);
    formData.append("index",index);
    Rails.ajax({
      url: this.removeimageurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response) => {
        console.log(response);
        const viewDiv = document.getElementById("image_view_"+targetName);
        const image = viewDiv.querySelector("img");
        image.src = "";
        viewDiv.classList.add(this.hideClass);
        document.getElementById("diagnostic_images_id_"+index).value = null;
        document.getElementById("image_upload_"+targetName).classList.remove(this.hideClass);
      }
    });
  }

  removeAddButton(index){
    if(index >= 2){
      this.addButtonTarget.classList.add('is-hidden')
    }
  }
}
